import classNames from 'classnames';
import { FunctionComponent } from 'react';
import Star from '../Star';
import styles from '../styles.module.scss';

export type StarsProps = {
    rating: number;
    maxRating: number;
    onClick?: (rating: number) => void;
};

const Stars: FunctionComponent<StarsProps> = ({ rating, onClick, maxRating = 5 }) => {
    const checkedStarsCount = Math.min(Math.max(rating, 0), maxRating);
    const description = onClick
        ? `Rate this item out of ${maxRating}`
        : `Rated ${rating} out of ${maxRating}`;

    const stars = Array(maxRating)
        .fill(0)
        .map((_, index) => {
            const value = index + 1;

            if (value <= checkedStarsCount) {
                return <Star key={index} value={value} onClick={onClick} checked={true} />;
            }

            return <Star key={index} value={value} onClick={onClick} checked={false} />;
        });

    const interactiveClassname = onClick ? styles.interactive : undefined;

    return (
        <div className={classNames(styles.stars, interactiveClassname)} aria-label={description}>
            {stars}
        </div>
    );
};

export default Stars;
